import { render, staticRenderFns } from "./Taxonomia.vue?vue&type=template&id=de47e272&scoped=true&"
import script from "./Taxonomia.vue?vue&type=script&lang=js&"
export * from "./Taxonomia.vue?vue&type=script&lang=js&"
import style0 from "./Taxonomia.vue?vue&type=style&index=0&id=de47e272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de47e272",
  null
  
)

export default component.exports